import { render, staticRenderFns } from "./BVNProviderChart.vue?vue&type=template&id=df541984&"
import script from "./BVNProviderChart.vue?vue&type=script&lang=js&"
export * from "./BVNProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports